import Component from './Component'

export default class ExamTimer extends Component {

	static _type = 'ExamTimer'

	_timer

	constructor (params) {
        super(params)

		// Default parameters
        this.params = Object.assign({
			target: null,
            format: 'HH:mm',
            interval: 1000
        }, this.params)
    }

	tether () {
		super.tether()

		this.update()
        this._timer = setInterval(this.update.bind(this), this.params.interval)
	}

    destroy() {

		// Stop the timer
        if (this._timer !== null) {
			clearInterval(this._timer)
			this._timer = null
		}

        super.destroy()
    }

    update() {
		// Draw the clock

		// Calculate remaining time in milliseconds
		const diff = Anvil.moment(this.params.target).diff(Anvil.moment()) + Anvil.REST.time_offset.asMilliseconds()
		if (diff <= 0) {
			// Time's up
			this.base.innerHTML = `<span class="text-danger"><i class="fa fa-stopwatch mr-2"></i>Lejárt az idő</span>`
		} else if (diff < 60000) {
			// Less than 5 minutes -> format to #0:00
			const d = Anvil.moment.duration(diff)
			this.base.innerHTML = `<span class="text-warning"><i class="fa fa-stopwatch mr-2"></i>${Math.trunc(d.minutes()).toString()}:${d.seconds().toString().padStart(2, '0')}</span>`
		} else if (diff < 3600000) {
			// Less than an hour -> format to #0:00
			const d = Anvil.moment.duration(diff)
			this.base.innerHTML = `<i class="fa fa-stopwatch mr-2"></i>${Math.trunc(d.minutes()).toString()}:${d.seconds().toString().padStart(2, '0')}`
		} else {
			// More than an hour -> format to #0:00:00
			const d = Anvil.moment.duration(diff)
			this.base.innerHTML = `<i class="fa fa-stopwatch mr-2"></i>${Math.trunc(d.asHours()).toString()}:${Math.trunc(d.minutes()).toString().padStart(2, '0')}:${d.seconds().toString().padStart(2, '0')}`
		}

		// Run callback if any
		if ('tick' in this.params) {
			this.params.tick(diff)
		}
    }
}
